import request from "_private/utils/request";

/**
 * @description  冷藏车信息列表接口
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
export function findByPage(data) {
  return request({
    url: "/examine/vehicleInfo/findByPage",
    method: "post",
    headers: { type: "json" },
    data
  });
}

/**
 * @description  冷藏车信息核查接口
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
export function findVehicleOfInfoById(data) {
  return request({
    url: "/examine/vehicleInfo/findVehicleOfInfoById",
    method: "post",
    // headers: { type: "json" },
    data
  });
}

/**
 * @description  冷藏车信息核查通过接口
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
export function verifyVehicleOfInfo(data) {
  return request({
    url: "/examine/vehicleInfo/verifyVehicleOfInfo",
    method: "post",
    headers: { type: "json" },
    data
  });
}

/**
 * @description  冷藏车信息下拉
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
export function findAllVehicles() {
  return request({
    url: "/examine/vehicleInfo/findAllVehicles",
    method: "post"
  });
}

/**
 * @description  Urgent冷藏车信息下拉
 * @author wangzhenxuan
 * @export
 * @param {*} data
 * @returns
 */
export function findAllUrgentVehicles() {
    return request({
        url: "/ug/vehicle/findAllUrgentVehicles",
        method: "post"
    });
}
